import phoneModelsObject from 'constants/phones.json';
import carsModelsObject from 'constants/cars.json';
import {uniq} from 'lodash';

const tvBrandsString =
    "Acer,Admiral,Admiral Overseas Corporation (AOC),Advent,Adyson,AGA,Aiwa,Akai,Akari,Akurra,Alba,Amplivision,Amstrad,Andrea Electronics,Anitech,Apex Digital,Arcam,Arena,Argosy Radiovision,Arise India,ASA,Astor,Asuka,Atlantic,Atwater Television,Audar,Automatic Radio Manufacturing,Audiovox,AVEL,AVol,AWA,Bace Television,Baird,Bang & Olufsen,Baumann Meyer,Beko,BenQ,Bell Television,BelTek Tv,Bharat,Beon,Binatone,BiSA,Bitova electronika Ltd,Blaupunkt,BLUE Edge,Blue Sky,Blue Star,Bondstec,BOSE,BPL india lmt,Brandt,Brionvega,Britannia,BrokSonic,BSR,BTC,Bush,Calbest Electronics,Candle,Capehart Electronics,Carrefour,Cascade,Cathay,Cello,Centurion,Certified Radio Labs,Cenfonix,CGE,Changhong,ChiMei,Cimline,Citizen,Clairetone Electric Corporation,Clarivox,Clatronic,CloudWalker,Coby,Colonial Radio,Color Electronics Corporation,Compal Electronics,Conar Instruments,Condor,Conrac (Monitors),Conrac (Germany),Contec,Continental Edison,Cortron Industries,Cossor,Craig,Crown,Crystal,CS Electronics,CTC,Curtis Mathes Corporation,Cybertron,Daewoo,Dainichi,Damro,Dansai,Dayton,De Graaf,Decca,Deccacolour (UK),Defiant,Dell,Delmonico International Corporation,Diamond Vision,Diboss,Digihome,Dixi,Dual,Dual Tec,Dumont,DuMont Laboratories,Durabrand,Dyanora (India),Dynatron,Dynex,Edler,Electron,Electronics Corp. (ECTV India),English Electric,English Electric Valve Company,EKCO,Elbe,Electrohome,Element,Elin,Elite,Elta,Emerson,Emerson,EMI,Erres,Expert,Farnsworth,Ferguson Electronics,Ferranti,Fidelity Radio,Finlandia,Finlux,FIRST,Firstline,Fisher Electronics,Fleetwood (CONRAC),Flint,Formenti,Frontech,Fujitsu,Funai,GC,Geloso,General Electric,General Electric Company plc,General Gold,Gene's TV,Geloso,Genexxa,GoldStar,Goodmans Industries,Gorenje,GPM,Gradiente,Graetz,Granada,Grandin,Grundig,Haier,Hannspree,Hanseatic,Hantarex,Harvard International,Harvey Industries,HCM,Healing,Helkama,Helvar,Heath Company,Hesstar,Hinari Domestic Applicanes,Hisawa,HMV,Hisense,Hitachi, Ltd.,HKC,Hoffman Television,Horizont,Howard Radio,Huanyu,Hypson,Ice,Ices,ITS,ITT Corporation,ITT-KB (UK),ITT-SEL (Germany),Imperial,INB,Indiana,Ingelen,Inno Hit,Innovex,Insignia,Interfunk,Intervision,Isukai,IZUMI,Jensen Loudspeakers,JMB,JVC,Kaisui,Kamacrown,Kane Electronics Corporation,Kapsch,Kathrein,Kendo,Kenmore,Kent Television,Khind,Kingsley,KIVI (Ukraine),Kloss Video,Kneissel,Kogan,Kolster-Brandes,Konka,Korpel,Koyoda,KTC,Lanix,Le.com,Leyco,LG Electronics,Liesenkötter,LLoyd's,Loewe AG,Luma,Luxor,M Electronic,MTC,Magnadyne,Magnafon,Magnasonic,Magnavox,Magnavox,Maneth,Marantz,Marconiphone,Mark,Matsui,Mattison Electronics,McMichael Radio,Mediator (brand name owned by Philips),Memorex,Micromax,Mercury-Pacific,Metz,Minerva,Minoka,Onida,Mitsubishi,Mivar,Motorola,Multitech (brand name only),Muntz,MT Logic (related to Multitech, brand name only),Murphy Radio,NASCO ELECTRONICS,NEC,Neckermann,Nelco,NEI,NEOS,NetTV,Nikkai,Nobliko,Nokia,Nordmende,North American Audio, Inc.,Olympic Radio and Television,Oceanic,oCosmo,OK tv,Olevia,One,Onida,Onwa,Orion (Hungary),Orion (Japan),Osaki,Oso,Osume,Otake,Otto Versand,Packard Bell,Palladium,Panama,Panasonic,Pathe Cinema,Pathe Marconi,Pausa,Perdio,Pensonic,Peto Scott,Philco,Philips,Philmore Manufacturing,Phonola,Pilot Radio,Jerrold Electronics,Pioneer,Planar Systems,Polar,Polaroid,Profex,Prima,Privé,ProLine,ProScan,ProTech,Pulser (own by Canadian tire),Pye,Pyle,PyxScape,Quasar,Quelle,Questa,R-Line,REI,Radiola,Radiola (France, owned by Philips),RadioMarelli,RadioShack,Rank Arena,Ravenswood,Rauland Borg,RBM,RCA,RCA (HKC,Realistic,Rediffusion,Regentone,Revox,Rex,RFT (Stassfurt plant),RGD (Radio Gramaphone Development Company),Roadstar,Rolls,Rolsen Electronics,Rubin,SABA,Saccs,Saisho,Salora,Salora International,Sambers,Sampo Corp. of America,Samsung,Sanabria Television Corporation,Sandra,Sansui,Sanyo,SBR,Sceptre,Schaub Lorenz,Schneider Electric,Schneider,Schneider,Sears (Silvertone),SEG,SEI,Sei-Sinudyne,Seiki Digital,Selco (India),Sèleco,Sentra,Setchell Carlson,Seura,Sharp,Airis,Shorai,Siarem,Siemens AG,Silo Digital,Skywalker,Silvertone,Sinudyne,Skyworth,Sobell,Solavox,Soniq,Sonitron,Sonoko,Sonolor,Sonora,Sontec,Sony,Soyo,Soundwave,Softlogic,Sparc,Stern,Stromberg Carlson,Stewart-Warner,SunLite TV,Sunkai,Susumu,Supersonic,Supra,Sylvania,Symphonic Electronic Corp,Symphonic Radio and Electronics,Sysline,Tandy,Technika TV,Tatung Company,TCL,Tec,Tech-Master,Technema,Technics,Technisat,Tecnimagen,Technika,TECO,Teleavia,Telebalt,Telefunken,Telemeister,Telequip,Teletech,Teleton,Teletronics,Television, Inc.,Temp,Tensai,Texet,Thomson SA,Thorn Electrical Industries,Thorn EMI,TMA,Tomashi,Toshiba,TPV Technology,TP Vision,Transvision,Trav-Ler Radop,Travelers Electronics Co.,Trinium Electronics Philippines,Triumph,Uher,Ultra,Ultravox,United States Television Manufacturing Corp.,Universum,Vestel,Videocon,Videosat,Videotechnic,Videoton,Viewsonic,Vision,Vistron,Vizio,Veon,Vu,V WORLD,Warwick,Watson,Watt Radio,Wells-Gardner,Westinghouse,Westinghouse Digital,Weston Electronics,White-Westinghouse,Witjas,Wybor,X2GEN,Xiaomi,Yoko,Yoko,Zanussi,Zenith Radio,Zonda";
export const tvBrands = uniq(tvBrandsString.split(','));
export const newsChannels = [
    'ATN News',
    '24 Horas',
    '3/24',
    'Aaj Tak',
    'ABC News',
    'Africanews',
    'ABP Live',
    'ABP News',
    'ABP Ananda',
    'adn40',
    'Al Jazeera',
    'Al Jazeera Balkans',
    'Al Jazeera English',
    'Al Jazeera Mubasher Al-‘Amma',
    'Asianet News',
    'BBC Arabic Television',
    'BBC News',
    'BBC Parliament',
    'BBC Persian Television',
    'BBC World News',
    'RTV SLO 3',
    'Bernama TV',
    'CBC News Network',
    'CCTV-13',
    'CGTN (TV channel)',
    'CGTN America',
    'CGTN Africa',
    'CGTN Arabic',
    'CGTN French',
    'CGTN Russian',
    'CGTN Spanish',
    'Channel NewsAsia',
    'ČT24',
    'DD News',
    'DW-TV',
    'Tagesschau24',
    'Euronews',
    'France 24',
    'France Info',
    'NPO Nieuws',
    'HRT 4',
    'IRINN',
    'Press TV',
    'HispanTV',
    'Al-Alam News Network',
    'Sahar TV',
    'News World India',
    'NDTV 24x7',
    'Asahi Newstar',
    'TBS News Bird',
    'NHK World TV',
    'Nile TV',
    'YTN',
    'PTV News',
    'Rai News 24',
    'RDI',
    'RTÉ News Now',
    'RTP3',
    'RT',
    'RT France',
    'RT UK',
    'RT America',
    'RT en Español',
    'RT Arabic',
    'RT Deutsch',
    'Russia 24',
    'SABC News International',
    'WION',
    'Zee 24Ghanta',
    'Zee News',
    'Zee Live',
    'Mirror Now',
    'TG Norba 24',
    'Telesur',
    'TRT Al Arabiya',
    'TRT Haber',
    'TRT Kurdî',
    'TRT World',
    'TVB iNews',
    'TVP Info',
    'VOA TV',
    'RTK 3',
    'TV5 (India)',
    'ANC',
    'Africa 24',
    'Ada Derana',
    'One News (Philippines)',
    'Inquirer 990 Television',
    'ARY News',
    'PTV World',
    'Apna News',
    'Arise News',
    'Astro Awani',
    'Band News',
    'BeritaSatu TV',
    'BFM TV',
    'Brigada News TV',
    'CBSN',
    'Channels TV',
    'City 42',
    'CNN',
    'CNN Airport',
    'CNN Chile',
    'CNN en Español',
    'CNN-News18',
    'CNN Indonesia',
    'CNN International',
    'CNN Philippines',
    'CNN Türk',
    'CP24',
    'CTV News Channel',
    'Dawn News',
    'DD Sahyadri',
    'Digi 24',
    'Din News',
    'Dunya News',
    'DXAB Teleradyo',
    'DYAB Teleradyo',
    'Dzaïr News',
    'DZMM TeleRadyo',
    'Nova24TV',
    'DZRH News Television',
    'Echo TV',
    'Echourouk News',
    'eNCA',
    'Ennahar TV',
    'ETV News Kannada',
    'ETV Marathi',
    'Express News',
    'Focus TV',
    'FOROtv',
    'Fox News Channel',
    'FTV News',
    'GEO News',
    'Global News Network',
    'Globo News',
    'Globovisión',
    'GMA News TV',
    'Headlines Today',
    'Hír TV',
    'HKBN News',
    'HLN',
    'i24news',
    'INews TV',
    'IBN-7',
    'IBN Lokmat',
    'Info TV',
    'i-Cable Live News Channel',
    'India News',
    'India Tv',
    'Indus News',
    'CNews',
    'Jai Maharashtra',
    'Jurnal TV',
    'Janasri News',
    'Kompas TV',
    'Espreso TV',
    'News7',
    'News 12 Networks',
    'Kanal 5',
    'Kasthuri Newz 24',
    'Kolkata TV',
    'KTN News',
    'Khyber News',
    'LCI',
    'LCN',
    'Manorama News',
    'MetroTV',
    'MNC News',
    'Milenio Televisión',
    'MSNBC',
    'Welt',
    'n-tv',
    'NDTV India',
    'NDTV Profit',
    'Ne Bangla',
    'News 24',
    'News One',
    'NewsX',
    'Niagara News TV',
    'NTV',
    'Nuestra Tele Noticias 24 Horas',
    'One America News',
    'Odisha TV',
    'Ora News',
    'OSN News',
    'Phoenix InfoNews Channel',
    'NPO Politiek',
    'Polsat News',
    'Polsat News 2',
    'Presse Africaine',
    'Public TV',
    'Raj News Kannada',
    'Record News',
    'Realitatea TV',
    'România TV',
    'Royal News',
    'Samaa News',
    'Samaya TV',
    'SIC Notícias',
    'Sindh TV News',
    'Sky News Australia',
    'Sky News New Zealand',
    'Sky News',
    'Sky News Arabia',
    'Saam TV',
    'Sky TG24',
    'STV Notícias',
    'Sun News Network',
    'Superstacja',
    'Suvarna News',
    'TA3',
    'Tara Newz',
    'TEZ',
    'TGCOM24',
    'TOLOnews',
    'Times Now',
    'TheBlaze',
    'TNN24',
    'Spring News',
    'Nation TV',
    'Todo Noticias',
    'Crónica TV',
    'C5N',
    'Canal 26',
    'América 24',
    'CN23',
    'TVB News Channel',
    'TV 2 Nyhetskanalen',
    'TV 2 News',
    'TV 24',
    'TVC News',
    'TVI 24',
    'TVN24',
    'TVN24 BiS',
    'TV9 (Telugu)',
    'TV9 (Kannada)',
    'Udaya News',
    'Waqt TV',
    'VSH News',
    'Zee 24 Taas',
    'Newsmax TV',
];

export const phoneBrands = Object.keys(phoneModelsObject);
export const phoneModels = phoneModelsObject;

export const carMakes = Object.keys(carsModelsObject);
export const carsModels = carsModelsObject;
